<template>
  <div class="display-wrapper fullscreen-wrapper">
    <fullscreen :fullscreen.sync="isFullscreen" style="background-color: #101129 !important;">
      <div class="display-content" v-if="toReload" style="position:relative">
        <div
          style="
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 35px;
                left: 0;
              "
        >
              <span @click="toggleApi" style="margin-right:2rem">
                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                <span class="fullscreen-btn" v-else>退出全屏</span>
              </span>
          <span @click="goback">
                <span class="fullscreen-btn">返回首页</span>
              </span>
        </div>
        <div
          style="
                width: 98%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 85px;
                left: 25px;
              "
        >
          <button class="cool-button" @click="goData" >综合数据</button>
          <button class="cool-button" @click="goOrgan" >组织架构</button>
          <button class="cool-button-active">教练员</button>
          <button class="cool-button" @click="goSite" >场地设施</button>
          <button class="cool-button" @click="goSchool">布点学校</button>
        </div>
          <!--左半边-->
          <div class="column left">
            <!--精英机构数量-->
            <div class="row class-all">
              <div class="com-wrapper">
                <div class="com-title">教练员统计</div>
                <div class="com-flex">
                  <div v-for="(item, index) in coachStatistics.coachArr" :key="item.name">
                    <div>{{item.value}}</div>
                    <div>{{item.name}}</div>
                  </div>
                </div>

                <div class="echart-class-status" id="echart-play-status"></div>
              </div>
            </div>
          </div>
          <!--中间-->
          <div class="column center">
             <div class="row class-all">
              <div class="com-wrapper">
                <div class="dTip">
                  <div class="dTip-title">教练员总人数</div>
                  <div class="number-value">{{coachStatistics.teacherLevelNum  }}</div>
                </div>
                <div style="margin-top: 5px;">
                  <div class="com-title">年龄分布</div>
                  <div class="data-wrapper">
                    <div id="age-distribution-chart" style="width: 100%; height: 300px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--右半边-->
          <div class="column right">
            <!--训练计划数量-->
            <div class="row class-all">
              <div class="com-wrapper">
                <div class="com-title">复合团队</div>
                <div class="com-flex">
                  <div v-for="(item, index) in coachStatistics.fuArr" :key="item.name">
                    <div>{{item.value}}</div>
                    <div>{{item.name}}</div>
                  </div>
                </div>

                <div class="echart-class-status" id="echart-play-status2"></div>
              </div>
            </div>
          </div>

      </div>
      <div class="display-content" style="background: none; padding: 0px 0.8rem;" v-if="toReload">
        <div class="column">
          <div class="row class-all">
            <div class="com-wrapper">
              <div class="com-title">精英机构教练分布</div>
              <div class="legend-control">
                    <button @click="toggleLegendCarousel" class="carousel-control-btn">
                      {{ isLegendCarouselPaused ? '▶' : '⏸' }}
                    </button>
                  </div>
                  <div class="data-wrapper">
                    <div style="height:380px;width:100%;" class="echart-associate-all" id="echart-associate-all"></div>
                  </div>
            </div>
          </div>
        </div>
        <div class="column" style="margin-left:1.5rem;flex:none;width:40%">
          <div class="row class-all">
            <div class="com-wrapper">
              <div class="com-title">青训总监</div>
              <div class="qxzj" style="height:380px;width:100%;" id="qxzj"></div>
            </div>
          </div>
        </div>
      </div>

    </fullscreen>
  </div>
</template>

<script>
  import VueFullscreen from "vue-fullscreen";
  import Vue from "vue";
  import  statistics  from "@/api/statistics";
  import yiyi from '@/assets/images/common/yioks_yiyi1.png'
  import keke from '@/assets/images/common/yioks_keke2.png'
  import echarts from "echarts";
  import {debounce} from '@/assets/js/utils';
  Vue.use(VueFullscreen);

  export default {
    data() {
      return {
        yiyi,
        keke,
        fullscreen: false,
        isFullscreen: false,
        toReload: true,
        coachStatistics: {
          coachArr: [
            {
              name:'E级',
              code:'E',
              value:0
            },
            {
              name:'D级',
              code:'D',
              value:0
            },
            {
              name:'C级',
              code:'C',
              value:0
            },
            {
              name:'B级',
              code:'B',
              value:0
            },
            {
              name:'A级',
              code:'A',
              value:0
            },
            {
              name:'职业级',
              code:'0',
              value:0
            },
            {
              name:'其他',
              code:'other',
              value:0
            }
          ],
          fuArr: [
            {
              name:'体能教练员',
              code:'TN',
              value:0
            },
            {
              name:'运动康复师',
              code:'YD',
              value:0
            },
            {
              name:'队医',
              code:'DY',
              value:0
            },
            {
              name:'其他',
              code:'QT',
              value:0
            },
          ],
          qxzj:[
            {
              name:'A级',
              code:'A',
              value:0
            },
            {
              name:'B级',
              code:'B',
              value:0
            },
            {
              name:'职业级',
              code:'PRO',
              value:0
            },
          ]
        },
        echartsList:[],
        userRankCountAge:[], // 年龄分布数据
        isLegendCarouselPaused: false, // 图例轮播暂停状态
        playerNumPRO:[],
        playerNumA:[],
        playerNumB:[],
        playerNumC:[],
        playerNumD:[], 
        playerNumE:[],
        playerKey:[],
        playerNumOther:[],
        legendInterval: null, // 添加这行来声明图例轮播定时器引用
      };
    },

    components:{
      
    },

    computed: {

    },
    destroyed() {
      if(this.legendInterval) {
        clearInterval(this.legendInterval);
      }
    },
    mounted() {
      this.isShowChild = false;
      statistics.getCoachStatistics().then(res => { 
        this.coachStatistics.teacherLevelNum = res.teacherLevelNum
        this.coachStatistics.coachArr.forEach(item => {
          item.value = res.teacherLevelMap[item.code]
        })
        this.coachStatistics.fuArr.forEach(item => {
          item.value = res.jstdMap[item.code]
        })
        this.userRankCountAge = this.transformAgeData(res.userRankCountAge);




        let playerNumPRO = [];
        let playerNumA = [];
        let playerNumB = [];
        let playerNumC = [];
        let playerNumD = [];
        let playerNumE = [];
        let playerKey = [];
        let playerNumOther = [];
        if(res.userRankCountOrg && res.userRankCountOrg.length){
          res.userRankCountOrg.forEach((item, index) => {
            playerNumPRO[index] = item.numPRO;
            playerNumA[index] = item.numA;
            playerNumB[index] = item.numB;
            playerNumC[index] = item.numC;
            playerNumD[index] = item.numD;
            playerNumE[index] = item.numE;
            playerNumOther[index] = item.numOther;
            playerKey[index] = item.playerKey;
          });
        }
        this.playerNumPRO = playerNumPRO;
        this.playerNumA = playerNumA;
        this.playerNumB = playerNumB;
        this.playerNumC = playerNumC;
        this.playerNumD = playerNumD;
        this.playerNumE = playerNumE;
        this.playerNumOther = playerNumOther;
        this.playerKey = playerKey;

        this.coachStatistics.qxzj.forEach(item => {
          item.value = res.zongjianMap[item.code]
        })
        this.$nextTick(() => {
          this.draw_play_status(this.coachStatistics.coachArr,'echart-play-status');  
          this.draw_play_status(this.coachStatistics.fuArr,'echart-play-status2');  
          this.drawAgeDistribution();
          this.draw_associate_all();
          this.draw_qing_zongjan(this.coachStatistics.qxzj);

          var that = this;
          window.onresize = debounce(function(){
            // 自动调整绘画区域大小
            that.echartsList.forEach(item => {
              item();
            });
      
          }, 100, false);
          this.fullscreenLoading = false;
        });
      })
      
      document.getElementsByTagName('html')[0].style.fontSize = '11px';
    },

    destroyed() {
      document.getElementsByTagName('html')[0].style.fontSize = '10.672358591248667vh';
    },


    methods: {
      toggleApi() {
        const that = this;
        this.$fullscreen.toggle(this.$el.querySelector(".fullscreen-wrapper"), {
          teleport: this.teleport, // 如果为true， 进入全屏时目标元素会被移动到document.body下；
          callback: (isFullscreen) => {
            that.fullscreen = isFullscreen;
          },
        });
      },
      goData(){
        this.$router.push({
          path: '/statistics',
        })
      },
      goSite(){
        this.$router.push({
          path: '/statisticsSiteFacilities',
        })
      },
      goSchool(){
        this.$router.push({
          path: '/statisticsSchool',
        })
      },
      goOrgan(){
        this.$router.push({
          path: '/statisticsOrganizational',
        })
      },
      goback(){
        this.$router.push({
          path: '/',
        })
      },
      draw_qing_zongjan(data){
        var myChart = echarts.init(document.getElementById('qxzj'));
        this.echartsList.push(myChart.resize);
        myChart.setOption({
          tooltip:{
            trigger:'item',
            formatter:'{b}:{c}人 （{d}%）'
          },
          legend: {
            left:'center',
            top:20,
            textStyle:{
              color:'#61a8ff'
            },
          },
          series: [
            {
              name: '青训总监',
              type: 'pie',
              radius: [60, 120],
              center: ['50%', '50%'],
              label:{
                formatter:'{b}:{c}人 （{d}%）',
                position:'top',
                show:true,
              },
              itemStyle: {
                borderRadius: 8
              },
              color:[
                '#68d8fe', '#fac858', '#ee6666'
              ],
              data: data
            }
          ]
        })
      },
       transformAgeData(ageData){
        // 定义等级顺序（与图表series顺序一致）
        const levelKeys = ['groupRankTypeE','groupRankTypeD', 'groupRankTypeC', 'groupRankTypeB', 'groupRankTypeA', 'groupRankTypeZhi','groupRankTypeOther'];
  
        // 定义年龄段顺序
        const ageGroups = [
          "20岁以下",
          "21-30岁",
          "31-40岁",
          "41-50岁",
          "51-60岁",
          "61岁以上"
        ];
  
        // 创建结果数组，5个等级，每个等级对应一个数组
        const result = [
          [], // E级
          [], // D级
          [], // C级
          [], // B级
          [], // A级
          [],  // 职业级(Zhi),
          []  // 其他
        ];
  
        // 按年龄段顺序提取各等级数据
        ageGroups.forEach(ageGroup => {
          levelKeys.forEach((levelKey, levelIndex) => {
            // 在当前等级中查找对应年龄段的数据
            const ageItem = ageData[levelKey].find(item => item[0] === ageGroup);
            // 如果找到则使用对应数值，否则为0
            result[levelIndex].push(ageItem ? ageItem[1] : 0);
          });
        });
  
        return result;
      },
      // 切换图例轮播暂停/开始状态
      toggleLegendCarousel() {
        this.isLegendCarouselPaused = !this.isLegendCarouselPaused;
      },
          // 绘制会员协会用户总量统计图表
      draw_associate_all(){
        // 创建一个方法来处理数据排序和图表更新
        const updateChartSort = (visibleSeries = ['E级','D级','C级','B级','A级','职业级','其他']) => {
          // 根据当前可见的系列计算总量
          const totalData = this.playerKey.map((key, index) => {
            let total = 0;
            if (visibleSeries.includes('E级')) total += this.playerNumE[index];
            if (visibleSeries.includes('D级')) total += this.playerNumD[index];
            if (visibleSeries.includes('C级')) total += this.playerNumC[index];
            if (visibleSeries.includes('B级')) total += this.playerNumB[index];
            if (visibleSeries.includes('A级')) total += this.playerNumA[index];
            if (visibleSeries.includes('职业级')) total += this.playerNumPRO[index];
            if (visibleSeries.includes('其他')) total += this.playerNumOther[index];
        
            return {
              key: key,
              total: total,
              e: this.playerNumE[index],
              d: this.playerNumD[index],
              c: this.playerNumC[index],
              b: this.playerNumB[index],
              a: this.playerNumA[index],
              pro: this.playerNumPRO[index],
              other: this.playerNumOther[index],
             
            };
          }).sort((a, b) => b.total - a.total);
      
          // 重新构建排序后的数据数组
          const sortedKeys = totalData.map(item => item.key);
          const sortedE = totalData.map(item => item.e);
          const sortedD = totalData.map(item => item.d);
          const sortedC = totalData.map(item => item.c);
          const sortedB = totalData.map(item => item.b);
          const sortedA = totalData.map(item => item.a);
          const sortedPRO = totalData.map(item => item.pro);
          const sortedOther = totalData.map(item => item.other);
      
          return {
            sortedKeys,
            sortedE,
            sortedD,
            sortedC,
            sortedB,
            sortedA,
            sortedPRO,
            sortedOther,
          };
        };
    
        // 初始排序
        const initialSort = updateChartSort();
    
        const optionOrgMark = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            textStyle: {
              color: '#61a8ff'
            },
            left: 'center',
            top: '1%',
            data: ['E级','D级', 'C级', 'B级', 'A级', '职业级', '其他'],
            selectedMode: 'multiple',
            selector: false
          },
          grid: {
            left: "5%",
            right: "2%",
            bottom: '20%'
          },
          xAxis: {
            type: 'category',
            axisLabel: {
              inside: 0,
              rotate: 60,
              textStyle: {
                color: "#61a8ff",
              },
            },
            data: initialSort.sortedKeys
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: "#61a8ff",
                width: 1,
                type: "solid",
              },
            },
          },
          series: [
            {
              name: 'E级',
              type: 'bar',
              stack: 'total',
              barwidth: "80%",
              color: '#d590c6',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: initialSort.sortedE
            },
            {
              name: 'D级',
              type: 'bar',
              stack: 'total',
              barwidth: "80%",
              color: '#61a8ff',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: initialSort.sortedD
            },
            {
              name: 'C级',
              type: 'bar',
              stack: 'total',
              barwidth: "80%",
              color: '#cb7832',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: initialSort.sortedC
            },
            {
              name: 'B级',
              type: 'bar',
              stack: 'total',
              barwidth: "80%",
              color: '#38ee15',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: initialSort.sortedB
            },
            {
              name: 'A级',
              type: 'bar',
              stack: 'total',
              barwidth: "80%",
              color: '#FAC858',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: initialSort.sortedA
            },
            {
              name: '职业级',
              type: 'bar',
              stack: 'total',
              barwidth: "80%",
              color: '#ed6666',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: initialSort.sortedPRO
            },
            {
              name: '其他',
              type: 'bar',
              stack: 'total',
              barwidth: "80%",
              color: '#90d5cd',
              label: {
                show: false
              },
              emphasis: {
                focus: 'series'
              },
              data: initialSort.sortedOther
            },  
            
          ]
        };
    
        // 设置图表
        const mapDom = document.getElementById("echart-associate-all");
        let class_status = echarts.init(mapDom);
        this.echartsList.push(class_status.resize);
        class_status.setOption(optionOrgMark);
    
        // 监听图例点击事件
        class_status.on('legendselectchanged', (params) => {
          // 获取当前选中的系列
          const selected = params.selected;
          const visibleSeries = Object.keys(selected).filter(key => selected[key]);
      
          // 重新计算排序
          const newSort = updateChartSort(visibleSeries);
      
          // 更新图表数据
          class_status.setOption({
            xAxis: {
              data: newSort.sortedKeys
            },
            series: [
              { data: newSort.sortedE },
              { data: newSort.sortedD },
              { data: newSort.sortedC },
              { data: newSort.sortedB },
              { data: newSort.sortedA },
              { data: newSort.sortedPRO },
              { data: newSort.sortedOther },
            ]
          });
        });
  
        // 实现图例轮播功能
        const legendNames = ['E级','D级', 'C级', 'B级', 'A级', '职业级', '其他'];
        let currentIndex = 0;
        let showAll = false;
  
        // 保存轮播定时器引用，便于后续清理
        let legendInterval = setInterval(() => {
          // 检查是否暂停
          if (this.isLegendCarouselPaused) {
            return;
          }
    
          let visibleSeries;
    
          if (showAll) {
            // 显示所有图例时
            const selected = {};
            legendNames.forEach(name => selected[name] = true);
            class_status.setOption({
              legend: {
                selected: selected
              }
            });
            visibleSeries = legendNames; // 使用所有图例进行排序
            showAll = false;
            currentIndex = 0;
          } else {
            // 只显示当前图例时
            const selected = {};
            legendNames.forEach((name, index) => {
              selected[name] = index === currentIndex;
            });
            class_status.setOption({
              legend: {
                selected: selected
              }
            });
            visibleSeries = [legendNames[currentIndex]]; // 当前图例进行排序
            currentIndex++;
            if (currentIndex >= legendNames.length) {
              showAll = true;
            }
          }
    
          // 确保排序逻辑总是执行
          const newSort = updateChartSort(visibleSeries);
    
          class_status.setOption({
            xAxis: {
              data: newSort.sortedKeys
            },
            series: [
              { data: newSort.sortedE },
              { data: newSort.sortedD },
              { data: newSort.sortedC },
              { data: newSort.sortedB },
              { data: newSort.sortedA },
              { data: newSort.sortedPRO },
              { data: newSort.sortedOther },
            ]
          });
        }, 10000);
        // 将定时器保存到组件实例，便于在组件销毁时清理
        this.legendInterval = legendInterval;
      },
      drawAgeDistribution(){
        const chartDom = document.getElementById('age-distribution-chart');
        if(!chartDom){
          return;
        }
    
        const myChart = echarts.init(chartDom);
        this.echartsList.push(myChart.resize);
        // 处理年龄分布数据
        const rawData = this.userRankCountAge;
        if(!rawData || rawData.length === 0){
          return;
        }
    
        // 计算总量数据
        const totalData = [];
        for(let i = 0; i < rawData[0].length; ++i){
          let sum = 0;
          for(let j = 0; j < rawData.length; ++j){
            sum += rawData[j][i];
          }
          totalData.push(sum);
        }
    
        // 等级名称映射
        const levelNames = ['E级','D级', 'C级', 'B级', 'A级', '职业级','其他'];
        const color = ['#d590c6','#61a7fe','#ca7832','#38ed15','#f9c758','#ec6666','#90d5cd'];
    
        // 构建系列数据
        const series = levelNames.map((name, sid) => {
          return {
            name,
            type:'bar',
            stack:'total',
            barWidth:'60%',
            itemStyle: {
              color: color[sid]
            },
            label:{
              show:true,
              formatter:(params) => Math.round(params.value * 1000) / 10 + '%'  // 显示百分比
            },
            data:rawData[sid].map((d, did) =>
              totalData[did] <= 0 ? 0 : d / totalData[did]
            )
          };
        });
    
        const option = {
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
              let result = '';
              params.forEach((item, index) => {
                if (index === 0) {
                  result += item.name + '<br/>';
                }
                // 使用原始数据获取具体人数
                const seriesIndex = item.seriesIndex;
                const dataIndex = item.dataIndex;
                const actualValue = rawData[seriesIndex][dataIndex];
                result += `${item.marker}${item.seriesName}: ${actualValue}人<br/>`;
              });
              return result;
            }
          },
          legend:{
            textStyle:{
              color:'#61a8ff'
            }
          },
          grid: {
            left: 60,
            right: 65,
            top: 50,
            bottom: 50
          },
          yAxis:{
            type:'value',
            max: 1,  // 将 Y 轴最大值固定为 1
            axisLabel:{
              textStyle:{
                color:'#61a8ff'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#61a8ff'
              }
            }
          },
          xAxis:{
            type:'category',
            data:[ '20岁以下', '21-30岁', '31-40岁', '41-50岁', '51-60岁', '61岁以上'],
            axisLabel:{
              textStyle:{
                color:'#61a8ff'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#61a8ff'
              }
            }
          },
          series
        };
    
        myChart.setOption(option);
        this.echartsList.push(myChart.resize);
      },
      draw_play_status(data,id){
        var myChart = echarts.init(document.getElementById(id));
        this.echartsList.push(myChart.resize);
        myChart.setOption({
          tooltip:{
            trigger:'item',
            formatter:'{b}:{c}人 （{d}%）'
          },
          legend: {
            left:'center',
            top:20,
            textStyle:{
              color:'#61a8ff'
            },
          },
          series: [
            {
              name: '教练员统计',
              type: 'pie',
              radius: '50%',
              color:['#d590c6','#61a7fe','#ca7832','#38ed15','#f9c758','#ec6666','#90d5cd'],
              data: data,
              label:{
                formatter:'{b}:{c}人 （{d}%）',
                position:'top',
                show:true,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        })
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable1'
  .display-wrapper
    width 100%
    height 100%
    font-size 12px !important
    background-color #101129 !important
  .display-content
    font-size 12px !important
    background-color #101129 !important
    min-width 1680px
    max-width 1920px
    margin 0 auto
    display flex
    padding 9rem 0.8rem 0
    background url('../../assets/images/display/logo.png') no-repeat 0 0 / contain
    .com-title{
      color: #68d8fe;
      font-weight: 600;
      font-size: 18px;
      padding-top:5px;
    }
    .dTip{
      text-align center;
      box-shadow: 0 0 30px rgba(104, 216, 254, .3);
      padding:10px;
      .dTip-title{ 
        color: #68d8fe;
        font-size: 24px;
        font-weight: 600;
        text-shadow: 0 0 10px rgba(104, 216, 254, .5);
        position: relative;
        z-index: 1;
      }
      .number-value{
        color #FFFFFF
        font-size 64px
        font-weight 800
        text-shadow 0 0 20px rgba(255, 255, 255, 0.8)
        margin 0 0 20px 0
        position relative
        z-index 1
        background linear-gradient(to right, #68D8FE, #FAC858, #EE6666)
        -webkit-background-clip text
        -webkit-text-fill-color transparent
        background-clip text
        animation glow 2s ease-in-out infinite alternate
      }
    }
    .com-wrapper{
      margin:-3rem -1rem -0.5rem -4rem;
      position relative;
      .legend-control{
        position absolute;
        right: 0;
        top: 0;
        .carousel-control-btn{
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: rgba(97, 168, 255, .2);
          border: 1px solid #61a8ff;
          color: #61a8ff;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
        }
      }
      .echart-class-status{
        height 392px
      }
      .com-flex{
        display flex;
        flex-wrap wrap;
        margin:10px 0px 20px 0px;
        &>div{
          text-align center;
          flex:1;
          font-size: 16px;
          &>div:nth-child(1){
            font-size: 24px !important;
            margin-top: 10px;
          }
          &>div:nth-child(2){
            color: #4c9bfd;
            margin-top: 8px;
          }
        }
      }
    }
    .cool-button
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #60c5e9, #2a4d6a);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .cool-button:hover
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      transform: skew(-15deg) translateY(-2px); /* 保持倾斜并提升按钮位置 */
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    .cool-button-active
      padding: 3px 10px;
      font-size: 14px;
      color: white;
      border: none;
      cursor: pointer;
      background: linear-gradient(45deg, #f9a825, #ff6b6b);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
      transition: all 0.3s ease;
      transform: skew(-15deg); /* 倾斜按钮 */
      margin: 0 2px
    .column
      position relative
      flex 3
      .row
        box-sizing border-box
        border 2px solid red
        border-image url('../../assets/images/display/border.png') 51 38 21 132
        border-width 4.125rem 1.583rem 0.875rem 5.5rem
        position relative
        margin-bottom 2rem
        color #FFFFFF
      .row-content
        position absolute
        top -4rem
        right -1.5rem
        bottom -0.875rem
        left -5.5rem
        padding 1.25rem 2rem
      .class-all
        min-height 110px
        .row-title
          color #68d8fe
          font-weight 600
          font-size 16px
          margin-bottom 0.4rem
          display flex
          align-items center
          .btn
            display flex
            align-items center
            justify-content center
            width 7rem
            height 2rem
            font-size 0.8rem
            margin 0 5px
            border-radius 2px
            cursor pointer
          .btn-active
            background-color #0bace6
            color #FFFFFF
        .data-wrapper
          display flex
          flex-wrap wrap
          .data-item
            flex 1
            font-size 12px
            text-align center
            .data
              font-size 26px
            .data-title
              color #4c9bfd
              margin-top 5px
      .class-table
        height 350px
        .row-content
          padding 1.25rem 0
        .nav-title-wrapper
          padding-left 1.25rem
          margin-bottom 0.8rem
          .nav-item
            margin-right 15px
            cursor pointer
            color #1950c4
            padding-right 15px
            border-right 2px solid #00f2f1
            &:last-child
              border-right none
          .active-title
            color #FFFFFF
        .table-wrapper
          .table-head
            display flex
            width 100%
            background-color rgba(255, 255, 255, 0.1)
            color #68d8fe
            padding 0 1rem
            line-height 3rem
            .table-column
              /* flex 1 */
              text-align center
              &:nth-child(1)
                width 20%
              &:nth-child(2)
                width 30%
              &:nth-child(3)
                width 20%
              &:nth-child(4)
                width 15%
              &:nth-child(5)
                width 15%
          .table-content
            height 250px
            overflow hidden
            .table-row
              width 100%
              display flex
              padding 0 1rem
              line-height 2.5rem
              color #61a8ff
              &:hover
                background-color rgba(255, 255, 255, 0.1)
                color #68d8fe
              .table-col
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
                text-align center
                &:nth-child(1)
                  width 20%
                &:nth-child(2)
                  width 30%
                &:nth-child(3)
                  width 20%
                &:nth-child(4)
                  width 15%
                &:nth-child(5)
                  width 15%
    .center
      flex 4
      margin 3.8rem 1.5rem 0
      .map-title
        color #68d8fe
        font-size 1.6rem
        text-align center
      .echart-map
        width 100%
        /* height 440px + 4.875rem */
        height 455px
      .online
        position absolute
        top -18px
        left 0
        z-index 999
        .online-content
          width inherit
          height inherit
          position absolute
          top -40px
          left -56px
          display flex
          flex-direction column
          .title
            width 100%
            color #68d8fe
            font-size 1.6rem
            line-height 4rem
            text-align center
          .content
            flex 1
            font-size 2.4rem
            display flex
            justify-content center
            align-items center
    .tutorial-add-level
      height 492px !important
      .data-wrapper
        height 85%
      .echart-tutorial-add
        width 100%
        height 100%
  .table-content
    .animation-wrapper
      animation row 20s linear infinite
      &:hover
        animation-play-state paused
  .tutorial-add
    height 350px !important
    .data-wrapper
      height 90%
    .echart-tutorial-add
      width 100%
      height 100%
  .login-data
    height 340px !important
    .data-wrapper
      height 90%
    .echart-user-login
      width 100%
      height 100%
  .class-vip
    height 340px !important
    .data-wrapper
      height 90%
    .echart-class-status
      width 100%
      height 100%
  .user-all
    height 340px !important
    margin-top 4.6rem
    .flex-box
      display flex
      width 100%
      height 100%
      .flex-item
        /* flex 1 1 */
        height 100%
        .data-wrapper
          height 90%
      .left
        flex 5
      .right
        flex 2
        padding 8rem 2rem 8rem 2rem
        display flex
        flex-direction column
        justify-content space-around
        font-size 1.4rem
        color #61a8ff
        text-align center
        .line-text
          /* text-align left */
          display flex
          justify-content space-between
          span:nth-child(1)
            display flex
            align-items center
            justify-content flex-start
          span:nth-child(2)
            font-size 2.5rem
            margin-left 5px
            color #FFFFFF
            text-align left
            display block
            width 6rem
    .echart-associate-all
      width 100%
      height 100%
  @keyframes row
    0%, 100%
      transform translateY(-50%)
  .fullscreen-btn
    color #61a8ff
    cursor pointer
</style>

<style lang="stylus" scoped>
  .h290
    height 290px
  .echart-map-wrapper
    height 462px
    box-sizing border-box
    padding-bottom 42px
    display flex
    justify-content space-around
  .pie-wrapper
    // height 250px
    height 290px
    width 100%
  .line-wrapper
    // height 250px
    height 290px
  .grade-wrapper
    height 290px
  .login-wrapper
    // height 250px
    height 290px
</style>

<style lang="stylus">
  .select-wrapper
    .el-input__inner
      background-color rgba(0, 0, 0, 0)
      border-color #0b93d5
      color #68d8fe
  /* .el-select-dropdown */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
  /* .el-select-dropdown__item.hover, .el-select-dropdown__item:hover */
  /* background-color #101129 !important */
  /* color #FFFFFF !important */
</style>
